import React from 'react'
import { TypeAnimation } from "react-type-animation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import styles from './Home.module.css'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';


export default function Home() {
  return (
    <div id={styles.home}>

      
      {/* <video muted autoPlay playsInline loop>
        <source src="glitch.mp4" type="video/mp4" />
        Your browser does not support the video tag. I suggest you upgrade your
        browser.
      </video> */}

      <img src="glitch.gif" alt='glitch background gif' className={styles.gif} />

      <div id={styles.text}>
        <div id={styles.name}>
          <TypeAnimation
            sequence={["Hi, I'm Tendai", 1000]}
            wrapper="span"
            speed={5}
            style={{ fontSize: "3em", display: "inline-block" }}
            repeat={Infinity}
          />
        </div>
        <div id={styles.fullstack}>
          <TypeAnimation
            sequence={["A FullStack Software Developer", 8000, ""]}
            wrapper="span"
            speed={5}
          
            repeat={Infinity}
          />
        </div>
        <div id={styles.logoContainer}>
          <a href="https://github.com/Tendaik96">
            <FontAwesomeIcon icon={faGithub} className={styles.icon} />
          </a>

          <a href="https://www.linkedin.com/in/tendai-karuwo/">
            <FontAwesomeIcon icon={faLinkedin} className={styles.icon} />
          </a>

          <a href="mailto:tendaikaruwo96@gmail.com">
            <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
          </a>
        </div>
      </div>
    </div>
  );
}
